import { render, staticRenderFns } from "./VueExcelEditor.vue?vue&type=template&id=22c1caad&scoped=true&"
import script from "./VueExcelEditor.vue?vue&type=script&lang=js&"
export * from "./VueExcelEditor.vue?vue&type=script&lang=js&"
import style0 from "./VueExcelEditor.vue?vue&type=style&index=0&id=22c1caad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c1caad",
  null
  
)

export default component.exports